<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="planType" label="计划类型">
              <el-select v-model="formData.planType" placeholder="请选择计划类型">
                <el-option v-for="item of planTypeList" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="dateDay" label="计划日期">
              <el-date-picker v-model="formData.dateDay" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item prop="planNum" label="计划产能">
              <el-input v-model="formData.planNum" placeholder="请输入计划产能" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="formData.planType === '1' ? '允许大车数量' : '允许罐车数量'" prop="vehicleNum">
              <el-input v-model="formData.vehicleNum" :placeholder="formData.planType === '1' ? '请输入允许大车数量' : '请输入允许罐车数量'" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="生效时间" prop="startTime">
              <el-date-picker v-model="formData.startTime" type="datetime" format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm" placeholder="生效时间" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
import { planType } from '@/utils/dict'
import { mapToObjectArray } from '@/utils/utils'
export default {
  name: 'PlanSettingAdd',
  data() {
    return {
      planTypeList: mapToObjectArray(planType),
      formData: {
        dateDay: '', // 日期
        planNum: '', // 计划产能
        vehicleNum: '', // 允许大车数量
        startTime: '',
        planType: ''
      },
      rules: {
        dateDay: [
          { required: true, message: '请输入日期' }
        ],
        planType: [
          { required: true, message: '请选择计划类型' }
        ],
        planNum: [
          { required: true, message: '请输入计划产能' }
        ],
        vehicleNum: [
          { required: true, message: '请输入允许数量' }
        ],
        startTime: [
          { required: true, message: '请选择生效时间' }
        ]
      }
    }
  },
  created() {
    if (this.dateId) {
      this.loadData()
    }
  },
  computed: {
    dateId() {
      return this.$route.query.dateId
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDateByDateId, { dateId: this.dateId }).then(res => {
        this.formData = res
      })
    },
    submit() {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.clyy.insertWlVehicleDate
        if (this.dateId) {
          url = this.$apis.clyy.updateWlVehicleDate
        }
        this.$axios.post(url, this.formData).then(() => {
          this.$router.back()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
